import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { humanizeMoney } from '../../../utils/formatters/money';
import styles from './InfoDoughnut.style';
import { ChartSize, } from './InfoDoughnut.types';
import Label from './Label';
const defaultThickness = 75;
const InProgressText = ({ currentValueText, description, textVariant, classes, color, }) => (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ align: "center", variant: textVariant, color: color, className: classes.wrapText }, { children: currentValueText })), _jsx(Typography, Object.assign({ align: "center", variant: "body1", color: color }, { children: description }))] }));
const InfoDoughnut = ({ classes, currentValue, maximumValue, description, currentValueLabel, secondaryLabel, thickness, hideLabels, size, currency, key, lightColor = '#b6a7de', darkColor = '#3f18aa', }) => {
    const leftOver = maximumValue !== null && currentValue !== null && maximumValue > 0
        ? maximumValue - currentValue
        : 0;
    const leftOverText = humanizeMoney(currency, leftOver, true);
    const currentValueText = currentValue !== null && humanizeMoney(currency, currentValue, true);
    const [textVariant, setTextVariant] = useState('h4');
    const [chartContainerClass, setChartContainerClass] = useState(classes.chartContainerLarge);
    const doughnutID = key ? `doughnut_${key}` : `doughnut`;
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: thickness || defaultThickness,
        tooltips: {
            callbacks: {
                label(tooltipItem, data) {
                    if (data.datasets && data.datasets[0] && data.datasets[0].data) {
                        const label = data.datasets[0].data[tooltipItem.index || 0];
                        return currency == null
                            ? 'No data'
                            : humanizeMoney(currency, label === 1 ? 0 : label, false, true);
                    }
                    return '';
                },
            },
        },
    };
    const legend = {
        display: false,
    };
    const data = {
        datasets: [
            {
                data: [
                    currentValue,
                    maximumValue !== null &&
                        currentValue !== null &&
                        maximumValue - currentValue >= 0
                        ? maximumValue - currentValue
                        : 0,
                ],
                backgroundColor: [
                    currentValue !== null && currentValue > 0 ? darkColor : lightColor,
                    lightColor,
                ],
                borderWidth: 0,
            },
        ],
    };
    const dataForZeroValues = {
        datasets: [
            {
                data: [1, 0],
                backgroundColor: [lightColor],
                borderWidth: 0,
            },
        ],
    };
    useEffect(() => {
        switch (size) {
            case ChartSize.Sm:
                setTextVariant('body2');
                setChartContainerClass(classes.chartContainerSmall);
                return;
            case ChartSize.Md:
                setTextVariant('body1');
                setChartContainerClass(classes.chartContainer);
                return;
            case ChartSize.Lg:
                setTextVariant('h4');
                setChartContainerClass(classes.chartContainerLarge);
                return;
            default:
                return;
        }
    }, [
        classes.chartContainer,
        classes.chartContainerLarge,
        classes.chartContainerSmall,
        size,
    ]);
    return (_jsxs("div", Object.assign({ className: classes.root }, { children: [_jsx("div", Object.assign({ className: chartContainerClass, id: doughnutID }, { children: maximumValue !== null && currentValue !== null ? (_jsxs(_Fragment, { children: [_jsx(Doughnut, { options: options, legend: legend, data: maximumValue === 0 && currentValue === 0
                                ? dataForZeroValues
                                : data }), _jsx("div", { id: "chart-legends" }), _jsx("div", Object.assign({ className: classes.chartText, style: { zIndex: '-1' } }, { children: _jsx(InProgressText, { classes: classes, textVariant: textVariant, currentValueText: currentValueText || '0', description: currentValue && description ? description : '', color: darkColor }) }))] })) : (_jsxs(_Fragment, { children: [_jsx(Doughnut, { options: options, legend: legend, data: dataForZeroValues }), _jsx("div", Object.assign({ className: classes.chartText }, { children: _jsx(InProgressText, { classes: classes, textVariant: textVariant, currentValueText: 'No data', description: '', color: darkColor }) }))] })) })), !hideLabels && (_jsxs("div", Object.assign({ className: classes.labels }, { children: [currentValue === 0 ? (_jsx(Label, { color: lightColor, label: currentValueLabel || '', value: currentValueText || '' })) : (_jsx(Label, { color: darkColor, label: currentValueLabel || '', value: currentValueText || '' })), _jsx(Label, { color: lightColor, label: secondaryLabel || description || '', value: leftOverText })] })))] })));
};
export default withStyles(styles)(InfoDoughnut);
